/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LinkStatus {
  DEFAULT = 'default',
  QR_NOT_CONFIGURED = 'qr_not_configured',
  QR_ACTIVE = 'qr_active',
}
